<!--
 * @Author: wangwei
 * @Date: 2020-12-28 16:06:28
 * @LastEditTime: 2021-01-15 11:25:31
 * @LastEditors: Please set LastEditors
 * @Description: 订单详情
 * @FilePath: /java-pc/src/views/member/order/List.vue
-->
<template>
  <div class="sld_order_detail">

    <div class="container">
      <div class="detail_operate_box">
        <div class="detail_operate_box_left">
          <div class="order_number">订单号: {{ order_info.data.orderSn }}</div>

          <!-- <div class="order_surplus_time" v-if="order_info.data.orderState==10">
            <img class="surplus_time_img" src="@/assets/order/warning.png" />
            <div class="surplus_time_text">请在 <span class="surplus_time_text_warning">{{formattedTime}}</span>内完成支付 </div>
          </div>
   
          <div class="order_surplus_time" v-if="order_info.data.isAfs == 1">
            <img class="surplus_time_img" src="@/assets/order/warning.png" />
            <div class="surplus_time_text">您有有一条售后信息，请点击查看 </div>
          </div> -->
        </div>
        <div v-if="order_info.data.zeroAfsSn!='0'">
          <!-- 待发货 -->
          <div class="operate_box" v-if="order_info.data.orderState==20">
            <div class="operate_btn primary_btn" @click="menuBtnClick('receipt',order_info.data)">确认收货</div>
          </div>
          <!-- 待收货 -->
          <div class="operate_box" v-if="order_info.data.orderState==30||order_info.data.orderState==31">
            <div class="operate_btn primary_btn" @click="menuBtnClick('receipt',order_info.data)">确认收货</div>
          </div>
          <!-- 已完成 -->
          <div class="operate_box" v-if="order_info.data.orderState==40">
            <!-- <div class="operate_btn" @click="menuBtnClick('',order_info.data)">再次购买</div> -->
          </div>
        </div>

        <div v-else>
          <!-- 已取消 -->
          <div class="operate_box" v-if="order_info.data.orderState==0">
            <!-- <div class="operate_btn" @click="menuBtnClick('delOrder',order_info.data)">删除订单</div> -->
            <!-- <div class="operate_btn" @click="menuBtnClick('',order_info.data)">再次购买</div> -->
          </div>
          <!-- 已关闭 -->
          <div class="operate_box" v-if="order_info.data.orderState==50">
            <!-- <div class="operate_btn" @click="menuBtnClick('delOrder',order_info.data)">删除订单</div> -->
            <!-- <div class="operate_btn" @click="menuBtnClick('',order_info.data)">再次购买</div> -->
          </div>
          <!-- 待付款 -->
          <div class="operate_box" v-if="order_info.data.orderState==10">
            <div class="operate_btn" @click="menuBtnClick('cancelOrder',order_info.data)">取消订单</div>
            <div class="operate_btn" @click="menuBtnClick('changeAddress',order_info.data)">修改地址</div>
            <div class="operate_btn primary_btn" @click="menuBtnClick('pay',order_info.data)">立即支付</div>
          </div>
          <div class="operate_box" v-if="order_info.data.orderState==11">
            <div class="operate_btn primary_btn" @click="presaleInfo.canPay? menuBtnClick('balancePayment',order_info.data):''">支付尾款</div>
          </div>
          <!-- 待发货 -->
          <div class="operate_box" v-if="order_info.data.orderState==20">
            <div class="operate_btn" v-if="order_info.data.isAfs != 1" @click="menuBtnClick('afterSale',order_info.data)">申请退款</div>
            <!-- <div class="operate_btn" @click="menuBtnClick('',order_info.data)">催发货</div> -->
          </div>
          <!-- 待收货 -->
          <div class="operate_box" v-if="order_info.data.orderState==30||order_info.data.orderState==31">
            <div class="operate_btn" v-if="order_info.data.isAfs != 1" @click="menuBtnClick('afterSale',order_info.data)">退款/售后</div>
            <!-- <div class="operate_btn" @click="menuBtnClick('delOrder',order_info.data)">删除订单</div> -->
            <!-- <div class="operate_btn" @click="menuBtnClick('',order_info.data)">查看物流</div> -->
            <div class="operate_btn" @click="menuBtnClick('',order_info.data)">查看发票</div>
            <div class="operate_btn primary_btn" @click="menuBtnClick('receipt',order_info.data)">确认收货</div>
          </div>
          <!-- 已完成 -->
          <div class="operate_box" v-if="order_info.data.orderState==40">
            <div class="operate_btn" @click="menuBtnClick('',order_info.data)">查看发票</div>
            <div class="operate_btn" v-if="order_info.data.isAfs != 1" @click="menuBtnClick('afterSale',order_info.data)">退款/售后</div>
            <!-- <div class="operate_btn">再次购买</div> -->
          </div>
        </div>
      </div>

      <!-- 订单状态 -->
      <div class="order_state_box">
        <div>
          <div class="state_title">订单状态：{{order_info.data.orderStateValue}}</div>
          <!-- 取消原因 -->
          <div class="state_text" v-if="order_info.data.orderState==0">
            {{order_info.data.refuseReason}}
          </div>
          <div class="state_text" v-if="order_info.data.orderState==10">
            请在<span class="state_time">{{formattedTime}}</span>内完成支付
          </div>
          <div class="state_text" v-if="order_info.data.orderState==20">
            您的订单已支付成功，等待出库
          </div>
          <div class="state_text" v-if="order_info.data.orderState==30||order_info.data.orderState==31">
            您的快递正在运输中
          </div>
          <div class="state_text" v-if="order_info.data.orderState==40">
            交易成功
          </div>
          <div class="state_text" v-if="order_info.data.orderState==11">
            <span class="state_time">{{order_info.data.presellInfo.remainStartTime}}</span>开始付尾款
          </div>
          <div class="state_text" v-if="order_info.data.isAfs == 1">
            您有一条售后信息，<span class="state_btn" @click="viewAfterSale">点击查看</span>
          </div>
        </div>
      </div>

      <!-- 订单处理信息 -->
      <!-- <div class="order_process">
        <div class="order_message_title">订单处理</div>
        <div class="table_header">
          <div class="table_header_item process_msg_time_width">
            处理时间
          </div>
          <div class="table_header_line"></div>
          <div class="table_header_item process_msg_content_width">
            处理信息
          </div>
        </div>
        <div class="process_msg_box">
          <div class="process_msg_table">
            <div v-for="v in 100" :key="v">{{v}}</div>
          </div>
        </div>
      </div> -->

      <!-- 收货信息 -->
      <div class="order_receiving">
        <div class="order_message_title">收货信息</div>
        <div class="table_header">
          <div class="table_header_item order_receiving_basic_width">
            基本信息
          </div>
          <div class="table_header_line"></div>
          <div class="table_header_item order_receiving_invoice_width">
            发票信息
          </div>
          <div class="table_header_line"></div>
          <div class="table_header_item order_receiving_delivery_width">
            配送信息
          </div>
        </div>
        <div class="receiving_table_box">
          <div class="receiving_table_item order_receiving_basic_width">
            <div class="message_item">
              <div class="message_item_label"> 姓名： </div>
              <div class="message_item_value"> {{order_info.data.receiverName}} </div>
            </div>
            <div class="message_item">
              <div class="message_item_label"> 收货地址： </div>
              <div class="message_item_value"> {{ order_info.data.receiverAreaInfo + order_info.data.receiverAddress }} </div>
            </div>
            <div class="message_item">
              <div class="message_item_label"> 联系电话： </div>
              <div class="message_item_value"> {{order_info.data.receiverMobile}} </div>
            </div>
          </div>

          <div class="receiving_table_item_line"></div>
          <div class="receiving_table_item order_receiving_invoice_width">
            <div class="message_item">
              <div class="message_item_label"> 发票类型： </div>
              <div class="message_item_value"> - </div>
            </div>
            <div class="message_item">
              <div class="message_item_label"> 发票抬头： </div>
              <div class="message_item_value"> - </div>
            </div>
          </div>
          <div class="receiving_table_item_line"></div>

          <div class="receiving_table_item order_receiving_basic_width">
            <div class="message_item">
              <div class="message_item_label"> 配送方式： </div>
              <div class="message_item_value"> {{order_info.data.deliverTypeValue}} </div>
            </div>
            <div class="message_item">
              <div class="message_item_label"> 运费： </div>
              <div class="message_item_value"> ¥{{formatNumberWithCommas(order_info.data.expressFee)}} </div>
            </div>

          </div>
        </div>
      </div>

      <div class="goods_table">
        <div class="order_message_title">商品信息</div>

        <table class="goods_table_container">
          <thead>
            <tr>
              <th>商品名称</th>
              <th>单价</th>
              <th>数量</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in order_info.data.orderProductList" :key="index">
              <td>
                <div class="goods_content">

                  <div class="goods_img" @click="goProductDetail(item.productId)"><img :src="item.productImage" alt=""></div>
                  <div class="goods_info">
                    <div class="goods_name">
                      <span class="goods_tag" v-if="item.isGift==1">赠品</span>
                      <span class="goods_tag" v-else-if="item.cartType==2">增值服务</span>
                      <span class="goods_tag" v-else-if="item.cartType==3">搭配</span>
                      {{ item.productShortTitle }}
                    </div>
                    <div class="goods_spec" v-if="item.specValues">
                      {{ item.specValues }}
                    </div>
                    <div v-if="item.afsStateValue" class="goods_status">
                      {{item.afsStateValue}}
                    </div>

                  </div>
                </div>
              </td>
              <td class="goods_price">

                <div> ¥{{ item.productShowPrice }}</div>
                <!-- 只有主商品才显示定金 -->
                <div v-if="index==0&&presaleInfo&&presaleInfo.balancePayType==1">(定金可抵¥{{presaleInfo.depositInflation}})</div>
                <div v-if="index==0&&presaleInfo&&presaleInfo.balancePayType==2">(尾款立减¥{{presaleInfo.discountFinalPayment}})</div>
              </td>
              <td class="goods_amount">x {{ item.productNum }}</td>
            </tr>
          </tbody>
        </table>
        <div class="snBox" v-if="order_info.data.productSn">
          SN码：{{order_info.data.productSn}}
        </div>

      </div>

      <div class="order_msg_box">
        <div class="order_remark_box">
          <div class="order_remark_title">订单备注</div>
          <div class="order_remark_content">
            {{ order_info.data.orderRemark || "无" }}
          </div>
        </div>
        <div class="order_info_box">

          <div>
            <!-- 定金订单  -->
            <div v-if="order_info.data.orderType == 103&&presaleInfo">
              <div class="pay_info_item">
                <div class="pay_info_item_lable">定金({{presaleInfo.firstPayStateValue}})：</div>
                <div class="pay_info_item_value">¥ {{presaleInfo.firstMoney}}</div>
              </div>
              <div class="pay_info_item">
                <div class="pay_info_item_lable">尾款({{ presaleInfo.secondPayStateValue }})：</div>
                <div class="pay_info_item_value">¥ {{presaleInfo.secondMoney}}</div>
              </div>
              <!-- 定金已付 -->
              <div v-if="presaleInfo.firstPayState==20">
                <div class="pay_info_item">
                  <div class="pay_info_item_lable">运费金额：</div>
                  <div class="pay_info_item_value">¥ {{formatNumberWithCommas(order_info.data.expressFee)}}</div>
                </div>
                <div class="pay_info_item">
                  <div class="pay_info_item_lable">优惠券抵扣：</div>
                  <div class="pay_info_item_value">- ¥ {{formatNumberWithCommas(order_info.data.couponDiscountAmount)}}</div>
                </div>
                <div class="pay_info_item" style="margin-bottom: 0;">
                  <div class="pay_info_item_lable">积分抵扣：</div>
                  <div class="pay_info_item_value">- ¥ {{formatNumberWithCommas(order_info.data.integralCashAmount)}}</div>
                </div>
              </div>
            </div>
            <!-- 无活动展示 -->
            <div v-else>

              <div class="pay_info_item">
                <div class="pay_info_item_lable">商品总价：</div>
                <div class="pay_info_item_value">¥ {{formatNumberWithCommas(order_info.data.goodsAmount)}}</div>
              </div>

              <div class="pay_info_item">
                <div class="pay_info_item_lable">运费金额：</div>
                <div class="pay_info_item_value">¥ {{formatNumberWithCommas(order_info.data.expressFee)}}</div>
              </div>
              <div class="pay_info_item">
                <div class="pay_info_item_lable">优惠券抵扣：</div>
                <div class="pay_info_item_value">- ¥ {{formatNumberWithCommas(order_info.data.couponDiscountAmount)}}</div>
              </div>
              <div class="pay_info_item" style="margin-bottom: 0;">
                <div class="pay_info_item_lable">积分抵扣：</div>
                <div class="pay_info_item_value">- ¥ {{formatNumberWithCommas(order_info.data.integralCashAmount)}}</div>
              </div>
            </div>

            <div class="pay_info_line"></div>
            <div class="pay_info_item">
              <div class="pay_info_item_lable" v-if="order_info.data.orderState==10">待付金额：</div>
              <div class="pay_info_item_lable" v-else>实付金额：</div>
              <div class="pay_info_item_main_value">¥ {{formatNumberWithCommas(order_info.data.orderAmount)}}</div>
            </div>
          </div>

          <div class="pay_btn_box">
            <div class="pay_btn" v-if="order_info.data.orderState==10" @click="menuBtnClick('pay',order_info.data)">立即支付</div>
            <div class="pay_btn" v-if="order_info.data.orderState==11" :class="{ 'opacity_pay':!presaleInfo.canPay}"
              @click="presaleInfo.canPay? menuBtnClick('balancePayment',order_info.data):''">支付尾款</div>
          </div>
        </div>
      </div>

    </div>
    <!-- 取消地址理由弹窗 start -->
    <el-dialog :title="''" v-model="cancel_order" customClass="select_reason_width" lock-sroll="false">
      <template #title>
        <div class="dialog_title">选择取消原因</div>
      </template>
      <div class="cancel_list_con_box">

        <div class="cancel_list_con">
          <div v-for="(reasonItem, index) in cancel_list.data" :key="index" :class="{
						reason_item: true,
						active: current_reason_id == reasonItem.reasonId
					}" @click="selectReason(reasonItem.reasonId)">
            <span class="reason_text">{{ reasonItem.content }}</span>

          </div>
        </div>
      </div>
      <div class="confirm_cancel_btn_box">
        <div class="confirm_cancel_btn" :class="{confirm_cancel_btn_opacity:!current_reason_id}" @click="confirmCancel()">{{ L['确定'] }}</div>
      </div>
    </el-dialog>
    <!--  取消地址理由弹窗 end  -->
    <!-- 地址选择弹窗 start -->
    <el-dialog :title="''" v-model="show_select_address" customClass="select_address_width" lock-sroll="false" :width="884">
      <template #title>
        <div class="dialog_title">{{L['修改地址']}}</div>
      </template>
      <div class="address_con_detail_page">
        <div v-for="(item, index) in address_list.data" :key="index" @click="selectAddress(index)" :class="{
					address_item: true,
					flex_column_start_start: true,
					select: current_address_index == index
				}">
          <div class="address_item_top">
            <span>{{ item.memberName }}</span>
            <span>{{ item.telMobile }}</span>
            <span class="address_tag" v-if="item.isDefault ==1">默认地址</span>
          </div>
          <div class="address_item_detail">
            {{ item.addressAll }} {{ item.detailAddress }}
          </div>
        </div>
      </div>
      <div class="confirm_address_btn_box">
        <div class="confirm_cancel_btn" @click="confirmChangeAddress()">
          {{ L['确定'] }}
        </div>
      </div>
    </el-dialog>
    <!-- 地址选择弹窗 end -->

    <!-- 全部按钮弹窗 start -->
    <el-dialog :title="''" v-model="show_all_order" :width="760" :before-close="closeAllOrder" lock-sroll="false" center>
      <template #title>
        <div class="dialog_title">以下订单需一起付款</div>
      </template>

      <div class="all_order_con">
        <div class="all_order_item" v-for="(v,i) in all_order_data.orderList" :key="i">
          <div class="all_order_item_top">
            <div class="all_order_item_no">{{v.orderSn}}</div>
            <div class="all_order_item_money">¥{{v.orderAmount}}</div>
          </div>
          <div class="all_order_item_count">共({{v.goodsNum}})件</div>
        </div>
        <div class="all_order_line"></div>
        <div class="all_order_item" style="margin-bottom:0px">
          <div class="all_order_item_top">
            <div class="all_order_item_no">合计</div>
            <div class="all_order_item_money">¥{{all_order_data.totalAmount}}</div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <el-button class="confirm_primary_btn" type="primary" @click="closeAllOrder(1)">确定</el-button>

        </div>
      </template>
    </el-dialog>
    <!-- 全部按钮弹窗 end -->
  </div>
</template>
<script>
import { reactive, getCurrentInstance, ref, onMounted, nextTick } from 'vue'
import {
  elBreadcrumb,
  elBreadcrumbItem,
  ElMessage,
  ElDialog,
  ElMessageBox,
  ElTimeline,
  ElTimelineItem
} from 'element-plus'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
  name: 'order-detail',
  components: {
    elBreadcrumb,
    elBreadcrumbItem,
    ElDialog,
    ElTimeline,
    ElTimelineItem
  },
  setup () {
    // const balance = require("../../assets/buy/balance.png");
    const store = useStore()
    const router = useRouter()
    const route = useRoute()
    const { proxy } = getCurrentInstance()
    const L = proxy.$getCurLanguage()
    const order_info = reactive({ data: {} })
    const express_empty = require('../../../assets/order/express_empty.png')
    const not_select = require('../../../assets/order/not_select.png')
    const selected = require('../../../assets/order/selected.png')
    const invoice_selected = require('../../../assets/buy/invoice_selected.png')
    const cancel_list = reactive({ data: [] })
    const cancel_order = ref(false) //是否显示取消订单弹窗
    const current_reason_id = ref() //记录当前已选择理由id
    const order_sn = ref('') //记录当前操作的订单号
    const show_select_address = ref(false) //是否显示选择地址弹窗
    const address_list = reactive({ data: [] }) //地址列表
    const current_address_index = ref(0) //记录当前选择的地址
    const logistics_info = reactive({
      data: {
        type: '',
        expressName: '',
        expressNumber: '',
        routeList: [],
        reason: ' '
      }
    }) //物流信息
    const configInfo = store.state.configInfo
    const afsState = ref(true)
    const remainProduct = reactive({ data: [] }); //待发货数据
    const deliverIndex = ref(0); //物流信息导航栏下标
    const deliverId = ref(null); //物流id
    const intervalId = ref(null); // 定时器ID
    const formattedTime = ref(null); // formattedTime
    const remainTime = ref(null); // remainTime
    const presaleInfo = ref(null); // remainTime
    const orderDetail = ref(null); // orderDetail

    const all_order_data = ref({}); // 全部相关订单
    const show_all_order = ref(false); // 全部相关订单展示

    const formatNumberWithCommas = (num) => {
      if (num === undefined || num === null) {
        return '';
      }

      const numberValue = Number(num);
      if (isNaN(numberValue)) {
        return '';
      }

      // 使用 toLocaleString 方法来添加千位分隔符（逗号），并保留两位小数
      return numberValue.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };


    /**
     * 待付款倒计时 start
     */
    const updateFormattedTime = () => {
      const hours = Math.floor(remainTime.value / 3600);
      const minutes = Math.floor((remainTime.value % 3600) / 60);
      const seconds = remainTime.value % 60;

      formattedTime.value = `${padZero(hours)}小时${padZero(minutes)}分${padZero(seconds)}秒`;
    };
    const padZero = num => {
      return num.toString().padStart(2, '0');
    };
    const startCountdown = () => {
      if (intervalId.value) {
        stopCountdown()
      }
      intervalId.value = setInterval(() => {
        if (remainTime.value > 0) {
          remainTime.value--;
          updateFormattedTime();
        } else {
          console.log("自动关闭倒计时")
          stopCountdown();
        }
      }, 1000);
    };
    const stopCountdown = () => {
      try {
        clearInterval(intervalId.value);
      } catch (e) {
        console.log("clearInterval err 重复清理interval")
      }
    };
    /**
     * 待付款倒计时 end
     */


    const getOrderDetail = () => {
      let config = {
        headers: {
          "Content-Type": "application/json",
        }
      };
      proxy
        .$post('v3/business/front/orderInfo/detail', {
          orderSn: route.query.orderSn
        }, config)
        .then(res => {
          if (res.state == 200) {
            order_info.data = res.data
            if (order_info.data.orderState >= 30) {
              lookLogistics();
            }

            if (res.data.orderState == 10) {
              // console.log("asdasdasd----->",res.data.remainTime)
              remainTime.value = res.data.remainTime;
              console.log("待付款时间----->", remainTime.value)
              updateFormattedTime();
              startCountdown();
            }
            // 定金订单
            if (res.data.orderType == 103) {
              let resPresaleInfo = res.data.presellInfo; //定金预售信息

              let topActive = false; // 定金左侧文本颜色
              let topTextActive = false; // 定金右侧文本颜色
              let bottomActive = false; // 尾款左侧文本颜色
              let bottomTextActive = false; // 尾款右侧侧文本颜色
              let lineActive = true;
              if (resPresaleInfo.firstPayState == 10) { // 定金待支付 待付款
                topActive = true;
                lineActive = true;
                topTextActive = true;
              } else if (resPresaleInfo.firstPayState == 20 && resPresaleInfo.secondPayState == 1) {
                // 定金已支付 尾款未开始
                lineActive = true;
                bottomActive = true
              } else if (resPresaleInfo.firstPayState == 20 && resPresaleInfo.secondPayState == 10) {
                // 定金已支付 尾款待支付
                lineActive = true;
                bottomActive = true;
                bottomTextActive = true;
              }

              // 当前是否可支付
              const now = new Date().getTime();
              const targetDate = new Date(resPresaleInfo.remainStartTime).getTime();

              let canPay = now > targetDate;
              console.log("now--->", now, targetDate)

              presaleInfo.value = {
                ...resPresaleInfo,
                topActive, topTextActive, bottomActive, bottomTextActive, lineActive, canPay
              };


              console.log("presaleInfo--->", presaleInfo, presaleInfo.value)
            }

          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }

    const goProductDetail = (productId) => {
			let newWin = router.resolve({
				path: `/goods/detail`,
				query: {productId:productId}
			})
			window.open(newWin.href, '_blank')
      //window.open(`/goods/detail?productId=${productId}`, '_blank');
    }


    // 按钮点击
    const menuBtnClick = (btnType, orderItem) => {
      orderDetail.value = orderItem;
      // console.log("operateBtn click_-------->", btnType, orderItem)
      if (btnType == 'pay') {
        // 合并支付
        if (orderItem.subOrderCount > 1) {
          getParentOrder(orderItem);// 获取父订单
          return
        }
        // 单独支付
        goPay(orderItem.paySn)
        return
      }
      if (btnType == 'cancelOrder') { // 取消订单
        showSelectReasonDialog(orderItem)
        return;
      }
      if (btnType == 'balancePayment') { // 支付尾款
        goPayBalance(orderItem);
        return
      }
      if (btnType == 'changeAddress') { // 修改地址
        editAddress(orderItem);
        return
      }
      if (btnType == 'receipt') { // 确认收货
        confirmReceipt(orderItem.orderSn)
        return
      }
      if (btnType == 'delOrder') { // 删除订单
        delOrder(orderItem.orderSn)
        return
      }
      if (btnType == 'afterSale') { // 退换售后
        let oderType;
        switch (orderItem.orderState) {
          case 20: // 待发货
            oderType = 1;
            break;
          case 30: // 待收货
            oderType = 2;
            break;
          case 31: // 待收货
            oderType = 2;
            break;
          case 40: // 已完成
            oderType = 3;
            break;
          default:
            // 处理其他情况，可选
            console.log('未知的 orderState');
            break;
        }
        router.push({
          path: '/member/order/refund/apply',
          query: {
            orderSn: orderItem.orderSn,
            orderType: oderType,///*orderType	1-待发货  2-待收货  3-已完成*/

          }
        })
        return
      }



      ElMessage("功能暂未开发，敬请期待")
    };
    // 查看售后
    const viewAfterSale = () => {
      router.push({
        path: '/member/order/aftersales',
        query: {


        }
      })
    }
    // 
    const goPayBalance = () => {

      console.log("presaleInfo.canPay--->", presaleInfo.value)
      if (!presaleInfo.value.canPay) return

      let mainProduct = order_info.data.orderProductList.filter(item => item.cartType == 1 && item.isGift === 0)

      let query = {}
      query.productId = mainProduct[0].productId;
      query.orderSn = order_info.data.orderSn;
      query.promotionType = mainProduct[0].promotionType;

      // return;
      router.push({
        path: '/buy/confirm',
        query: query
      })
    };
    // 获取订单取消理由列表
    const getCancelList = () => {
      proxy
        .$get('v3/system/front/reason/list', {
          type: 104
        })
        .then(res => {
          if (res.state == 200) {
            cancel_list.data = res.data
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //选择理由
    const selectReason = id => {
      current_reason_id.value = id
    }
    //显示选择理由弹窗
    const showSelectReasonDialog = orderSn => {
      if (
        !order_info.data.isRefundDeposit &&
        (order_info.data.orderType == 105 ||
          order_info.data.orderType == 103) &&
        order_info.data.orderSubState == 102
      ) {
        ElMessageBox.confirm(L['取消该订单定金不予退还,确定取消?'], L['提示'], {
          confirmButtonText: L['确定'],
          cancelButtonText: L['取消'],
          type: 'warning'
        }).then(() => {
          cancel_order.value = true
          order_sn.value = orderSn
        })
      } else {
        cancel_order.value = true
        order_sn.value = orderSn
      }
    }
    //确认取消订单
    const confirmCancel = () => {
      if (!current_reason_id.value) {
        ElMessage.warning(L['请选择取消理由'])
        return
      }
      proxy
        .$post('v3/business/front/orderOperate/cancel', {
          parentSn: order_sn.value,
          reasonId: current_reason_id.value
        })
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['取消订单成功'])
            cancel_order.value = false
            getOrderDetail()
          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    //删除订单
    const delOrder = orderSn => {
      ElMessageBox.confirm(L['确认删除该订单?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: 'warning'
      }).then(() => {
        proxy
          .$post('v3/business/front/orderOperate/delete', {
            orderSn
          })
          .then(res => {
            if (res.state == 200) {
              ElMessage.success(L['删除订单成功'])
              router.go(-1)
            } else {
              ElMessage(res.msg)
            }
          })
      })
    }
    //确认收货
    const confirmReceipt = orderSn => {
      ElMessageBox.confirm(L['确认收货?'], L['提示'], {
        confirmButtonText: L['确定'],
        cancelButtonText: L['取消'],
        type: 'warning'
      })
        .then(() => {
          proxy
            .$post('v3/business/front/orderOperate/receive', {
              orderSn
            })
            .then(res => {
              if (res.state == 200) {
                ElMessage.success(L['确认收货成功'])
                getOrderDetail()
              } else {
                ElMessage(res.msg)
              }
            })
            .catch(() => {
              //异常处理
            })
        })
        .catch(() => { })
    }
    //选择地址
    const editAddress = order => {
      show_select_address.value = true
      order_sn.value = order.orderSn

      let {
        receiverAddress,
        receiverAreaInfo,
        receiverMobile,
        receiverName
      } = order

      let index = address_list.data.findIndex(i => {
        let { addressAll, memberName, telMobile, detailAddress } = i
        if (
          memberName == receiverName &&
          receiverMobile == telMobile &&
          receiverAddress == detailAddress &&
          addressAll == receiverAreaInfo
        ) {
          return true
        } else {
          return false
        }
      })

      if (index > -1) {
        current_address_index.value = index
      } else {
        current_address_index.value = -1
      }
    }
    //获取地址列表
    const getAddressList = () => {
      proxy.$get('v3/member/front/memberAddress/list').then(res => {
        if (res.state == 200) {
          address_list.data = res.data.list
        } else {
          ElMessage(res.msg)
        }
      })
    }
    //切换地址
    const selectAddress = index => {
      current_address_index.value = index
    }
    //确认修改地址
    const confirmChangeAddress = () => {
      proxy
        .$post('v3/business/front/orderOperate/updateAddress', {
          orderSn: order_info.data.orderSn,
          addressId: address_list.data[current_address_index.value].addressId
        })
        .then(res => {
          if (res.state == 200) {
            ElMessage.success(L['切换地址成功'])
            show_select_address.value = false
            getOrderDetail()
          } else {
            ElMessage(res.msg)
          }
        })
    }
    //显示查看物流信息
    const lookLogistics = () => {
      let param = {}
      if (order_info.data.orderDeliver) {
        param.deliverId = order_info.data.orderDeliver.deliverId
      } else if (order_info.data.orderDeliverList && order_info.data.orderDeliverList.length > 0) {
        param.deliverId = order_info.data.orderDeliverList[deliverIndex.value].deliverId
      } else {
        return;
      }
      // 获取已发货数据
      proxy.$get("v3/business/front/logistics/order/getTrace", param).then(res => {
        if (res.state == 200) {
          if (!res.data.reason) {
            res.data.reason = '暂无详细物流信息';
          }
          logistics_info.data = res.data;
          //如果传过来的路由参数有hash值，一般是该dom元素的id值，让其滚入视图上
          if (route.hash) {
            nextTick(() => {
              document.querySelector(route.hash).scrollIntoView({
                block: "center",
                inline: "nearest",
                behavior: 'smooth'
              })
            })
          }
        } else {
          ElMessage(res.msg);
        }
      })
      if (order_info.data.orderDeliverList && order_info.data.orderDeliverList.length > 0) {
        let params = { orderSn: route.query.orderSn }
        // 获取待发货数据
        proxy.$get("v3/business/front/orderInfo/orderProductList", params).then(res => {
          if (res.state == 200) {
            remainProduct.data = res.data;
          }
        })
      }
    }
    //切换发货方式
    const changeDeliver = (index) => {
      deliverIndex.value = index;
      logistics_info.routeList = [];
      lookLogistics();
    };
    //查看待发货
    const showRemain = () => {
      deliverIndex.value = order_info.data.orderDeliverList.length;
    };
    //评价订单
    const remainEvaluated = orderSn => {
      router.push({
        path: '/member/order/evaluate',
        query: {
          orderSn: orderSn
        }
      })
    }
    //立即支付
    const goPay = orderSn => {
      router.push({
        path: '/buy/pay',
        query: {
          paySn: orderSn,
          payFrom: 2
        }
      })
    }

    const getParentOrder = orderItem => {

      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let param = {};
      param.parentSn = orderItem.parentSn;
      proxy
        .$post('v3/business/front/orderInfo/detailParent', param, config)
        .then(res => {
          if (res.state == 200) {
            all_order_data.value = res.data;
            show_all_order.value = true;

          } else {
            ElMessage(res.msg)
          }
        })
        .catch(() => {
          //异常处理
        })
    }
    const closeAllOrder = (payType) => {
      show_all_order.value = false
      if (payType == 1) {
        console.log("roderDetail--->", orderDetail.value.paySn)
        goPay(orderDetail.value.paySn)
        all_order_data.value = {};
      }
    }
    //选择售后服务
    const selectService = (orderProductId, orderSn) => {
      proxy
        .$get('v3/business/front/after/sale/apply/applyInfo', {
          orderSn,
          orderProductId
        })
        .then(res => {
          if (res.state == 200) {
            router.push({
              path: '/member/order/refund/apply',
              query: {
                orderState: order_info.data.orderState,
                orderProductId
              }
            })
          } else {
            ElMessage(res.msg)
          }
        })
    }
    //查看售后详情
    const goRefundDetail = afsSn => {
      router.push({
        path: '/member/order/refund/detail',
        query: {
          orderState: order_info.data.orderState,
          afsSn
        }
      })
    }

    onMounted(() => {
      getOrderDetail()
      getCancelList()
      getAddressList()
    })
    return {
      L,
      order_sn,
      order_info,
      express_empty,
      showSelectReasonDialog,
      cancel_list,
      current_reason_id,
      selectReason,
      cancel_order,
      not_select,
      selected,
      confirmCancel,
      delOrder,
      confirmReceipt,
      editAddress,
      confirmChangeAddress,
      selectAddress,
      current_address_index,
      address_list,
      show_select_address,
      invoice_selected,
      logistics_info,
      remainEvaluated,
      selectService,
      goPay,
      goRefundDetail,
      afsState,
      configInfo,
      lookLogistics,
      deliverIndex,
      deliverId,
      changeDeliver,
      remainProduct,
      showRemain,
      formattedTime,
      formatNumberWithCommas,
      presaleInfo,
      menuBtnClick,
      goProductDetail,
      closeAllOrder,
      all_order_data,
      show_all_order,
      viewAfterSale
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../style/member/orderDetail.scss";

.order_remark {
  margin-bottom: 20px;
  line-height: 30px;
  word-break: break-all;
}
</style>
